module.exports = __webpack_public_path__ + "assets/img/pop-2.d7cfcf57.jpg";